module.exports = __webpack_public_path__ + "amcharts/images/lensWhite_old.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lensWhite_old.png
// module id = 274
// module chunks = 0